<ion-content [ngClass]="backGroundImageToShow">
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size-xl="4" size-lg="6" size-md="8" size-sm>
        <ion-card>
          <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <div class="logo-container">
              <img src="./assets/images/login_logo_white.png" />
            </div>
            <div>
              <div class="input-group">
                <div class="label-container">
                  <ion-label class="white">Email</ion-label>
                </div>
                <ion-input
                  type="email"
                  name="email"
                  formControlName="email"
                  placeholder="Your email"
                  (ionFocus)="emailFocus()"
                ></ion-input>
              </div>
              <div class="input-group">
                <div class="label-container">
                  <ion-label class="white">Password</ion-label>
                </div>
                <ion-input
                  *ngIf="!showPassword"
                  type="password"
                  name="password"
                  formControlName="password"
                  placeholder="Your password"
                  (ionFocus)="passwordFocus()"
                  (keyup.enter)="onLogin()"
                ></ion-input>
                <ion-input
                  *ngIf="showPassword"
                  type="text"
                  name="password"
                  formControlName="password"
                  placeholder="Your password"
                  (ionFocus)="passwordFocus()"
                  (keyup.enter)="onLogin()"
                ></ion-input>
                <img
                  class="show-password-icon"
                  tappable
                  (click)="switchShowPassword()"
                  *ngIf="showPassword"
                  src="./assets/icon/eye-fill.svg"
                />
                <img
                  class="show-password-icon"
                  tappable
                  (click)="switchShowPassword()"
                  *ngIf="!showPassword"
                  src="./assets/icon/eye-slash-fill.svg"
                />
              </div>
            </div>
            <div
              tappable
              class="forget-password-container"
              routerLink="/password-reset"
            >
              <span> Forgot your password? </span>
            </div>
            <div class="notes-container">
              <span class="notes">
                By logging in, you agree to our
                <b tappable (click)="onTermsOfService()">Terms of Services</b>
                and <b tappable (click)="onPrivacyPolicy()">Privacy Policy</b>
              </span>
            </div>
            <ion-button
              color="light"
              type="submit"
              expand="block"
              tappable
              [disabled]="!loginForm.valid || !isFormInput"
            >
              Log in
            </ion-button>
            <ion-button
              class="sign-up-btn"
              expand="block"
              fill="clear"
              tappable
              routerLink="/register"
            >
              New to salonMonster? Sign up!
            </ion-button>
          </form>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="login-page-app-version">{{ appVersion }}</div>
</ion-content>
